/*
 * <omosa-autoplay-video>: product videos that play on their own (snippets/autoplay-video.liquid).
 * Loading starts when the video is about to come into view (one screen ahead, also sideways in a
 * row of photos), playback when half of it is on screen, pause when it leaves. Reduced motion, data
 * saver or 2G: no autoplay, the player buttons are shown. A tap pauses or plays and keeps that choice.
 */
const quiet = () => {
  const connection = navigator.connection;
  return matchMedia('(prefers-reduced-motion: reduce)').matches || connection?.saveData || /2g/.test(connection?.effectiveType || '');
};

class OmosaAutoplayVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video || this.started) return;
    this.started = true;
    if (quiet()) {
      this.video.controls = true;
      this.video.preload = 'metadata';
      return;
    }
    this.near = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      this.near.disconnect();
      this.video.preload = 'auto';
      this.video.load();
    }, { rootMargin: '100% 100%' });
    this.seen = new IntersectionObserver(([entry]) => {
      if (this.pausedByVisitor) return;
      if (entry.isIntersecting) this.video.play().catch(() => (this.video.controls = true)); // refused (e.g. low power mode): buttons
      else this.video.pause();
    }, { threshold: 0.5 });
    this.near.observe(this);
    this.seen.observe(this);
    this.video.addEventListener('click', () => {
      this.pausedByVisitor = !this.video.paused;
      if (this.pausedByVisitor) this.video.pause();
      else this.video.play();
    });
  }

  disconnectedCallback() {
    this.near?.disconnect();
    this.seen?.disconnect();
    this.started = false;
  }
}

if (!customElements.get('omosa-autoplay-video')) customElements.define('omosa-autoplay-video', OmosaAutoplayVideo);
